import axios from "axios";
import axiosInstance from "./axiosInstance";
import {
  CreateQarzanApplicationPayload,
  QarzanTypesApi,
} from "types/qarzanHassana";

export interface QarzanHasanaFilters {
  pageNo?: number;
  pageSize?: number;
  searchTerm?: string;
  qarzantypeName?: string;
  qarzanCode?: string;
  status?: string;
}

// Helper to get token safely
export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getQarzanListTypes = async (): Promise<QarzanTypesApi[]> => {
  const res = await axiosInstance.get("/qarzan-type", {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const getQarzanHasanaStatics = async () => {
  try {
    const response = await axiosInstance.get(`/QarzanApplication/stats`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getQarzanHasanaList = async (
  filters: QarzanHasanaFilters = {},
) => {
  try {
    const response = await axiosInstance.get("/QarzanApplication/list", {
      params: {
        pageNo: filters.pageNo ?? 0,
        pageSize: filters.pageSize ?? 20,
        searchText: filters.searchTerm || undefined,
      },
      headers: {
        ...getAuthHeader(),
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEmployeeDetails = async () => {
  try {
    const response = await axiosInstance.get(`/Auth/me/employee`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createQarzanApplication = async (
  payload: CreateQarzanApplicationPayload,
) => {
  try {
    const response = await axiosInstance.post("/QarzanApplication", payload, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getQarzanApplicationById = async (PublicId: string) => {
  try {
    const response = await axiosInstance.get(
      `/QarzanApplication/${PublicId}/with-documents`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateQarzanApplicant = async (
  formData: FormData,
  publicId: string,
) => {
  try {
    const response = await axiosInstance.put(
      `QarzanApplication/${publicId}/with-documents`,
      formData,
      {
        headers: {
          ...getAuthHeader(),
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return { success: true, data: response.data };
  } catch (error: unknown) {
    if (axios.isAxiosError(error) && error.response?.data) {
      return {
        success: false,
        message: error.response.data.message || "Validation failed",
        errors: error.response.data.errors || {},
      };
    }
    return {
      success: false,
      message: "Something went wrong",
      errors: {},
    };
  }
};

export const deleteQarzanApplicant = async (
  guid: string,
  deletedBy: string,
): Promise<void> => {
  await axiosInstance.delete(`/qarzan-type/${guid}`, {
    params: {
      deletedBy,
    },
    headers: {
      ...getAuthHeader(),
    },
  });
};


export const reUploadQarzanApplicantDocuments = async (formData: FormData) => {
  try {
    const response = await axiosInstance.post(
      `/QarzanApplication/document/re-upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to re-upload tour operator document", error);
    throw error;
  }
};

